import React, { FC, useEffect, useState } from 'react';

import { includes, map, startCase, sum } from 'lodash';
import round from 'lodash/round';
import { useSelector } from 'react-redux';

import { getIconColor } from 'components/DataDisplay';
import { IconTypes } from 'components/Icons';
import { selectActiveResource } from 'containers/ActiveCloudResource/selectors';

import { Breakdown } from './Breakdown';

interface DistributionByDataLabelsProps {
  label?: string;
}

export const DistributionByDataLabels: FC<DistributionByDataLabelsProps> = ({
  label = 'Breakdown by Sensitive Data Categories',
}) => {
  const { data } = useSelector(selectActiveResource);
  const { data: labels, isLoading } = data.dataLabels;
  const [chartData, setChartData] = useState<Record<string, any>[]>([]);

  useEffect(() => {
    const total = sum(Object.values(labels));
    setChartData(
      map(labels, (o, key) => ({
        name: includes(['pii', 'pci', 'phi'], key)
          ? key?.toUpperCase()
          : startCase(key),
        value: o,
        percent: !!total ? round((o / total) * 100) : 0,
      })),
    );
  }, [labels]);

  const colorMap = {
    PII: getIconColor(IconTypes.PII),
    PCI: getIconColor(IconTypes.PCI),
    PHI: getIconColor(IconTypes.PHI),
    Credential: getIconColor(IconTypes.Sensitive),
    Custom: 'primary',
  };

  return (
    <Breakdown
      data={chartData}
      isLoading={isLoading}
      label={label}
      colorMap={colorMap}
    />
  );
};
